// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"3235d253","703":"31b2af16"}[chunkId] + ".chunk.js";
};